import React from 'react'
import Sidebar from "../components/sidebar";
import Header from '../components/Header';
import SubscriptionAdd from '../components/Subscription/SubscriptionAdd'

function SubAddScreen() {
  return (
    <>
        <Sidebar />
        <main className="main-wrap">
            <Header />
            <SubscriptionAdd />
        </main>
    </>
  )
}

export default SubAddScreen